export class CatagoryData {
    articleType: string;
    createdDate: string;
    feature: boolean;
    htmlContent: string;
    id: number
    imagePath: string;
    modifiedDate: string;
    month: string;
    pdfUrl: string;
    shortDesc:string;
    thumbnailImage: string;
    title: string;
    type: string;
    video: string;
    year: string;
}